module.exports = __webpack_public_path__ + "img/首页海报3.b73586b3.png";